

const Inscripcion = props => {

    const state = props.state;

    return(
       <>
        <h5>Inscripción</h5>
        <h6 className="text-dark fw-normal">Información del encargado o representante:</h6>
        <div className="mt-2">
            <div className="row">
                <div className="col-md-12">
                    <div className="mb-2">
                        <label htmlFor="nombres" className="form-label text-primary ">Nombre Completo<span className="text-dark fst-italic ms-1">(Obligatorio)</span></label>
                        <input type="text" className="text-uppercase form-control form-control-sm" id="nombres" name="nombres" value={state.nombres} onChange={e => props.handleOnChangeText(e)}/>
                        <div className="text-danger invalid-text text-start">{props.error.nombres}</div>
                    </div>
                </div>
                <div className="col-12 col-md-12">
                    <div className="mb-2">
                        <label htmlFor="celular" className="form-label text-primary">Celular <span className="text-dark fst-italic ms-1">(Obligatorio)</span></label>
                        <div className="input-group input-group-sm mb-2 mr-sm-2">
                            <div className="input-group-text">+56 9</div>
                            <input maxLength={8} type="text" className="form-control " id="celular" name="celular" value={state.celular} onChange={e => props.handleChangeSoloNum(e)}/>
                        </div>
                        <div className="text-danger invalid-text text-start">{props.error.celular}</div>
                    </div>
                </div>
                <div className="col-12 col-md-12">
                    <div className="mb-2">
                        <label htmlFor="telefono_fijo" className="form-label text-primary">Teléfono  Fijo</label>
                        <input type="text" maxLength={9} className="form-control form-control-sm" id="telefono_fijo" name="telefono_fijo" value={state.telefono_fijo} onChange={e => props.handleChangeSoloNum(e)}/>
                    </div>
                </div>
                <div className="col-12 col-md-12">
                    <div className="mb-2">
                        <label htmlFor="mail" className="form-label text-primary">Tu correo electrónico <span className="text-dark fst-italic ms-1">(Obligatorio)</span></label>
                        <input type="text" className="form-control form-control-sm" id="mail" name="mail" value={state.mail} onChange={e => props.handleOnChangeText(e)}/>
                        <div className="text-danger invalid-text text-start">{props.error.mail}</div>
                    </div>
                </div>
                <div className="col-12 col-md-12">
                    <div className="mb-2">
                        <label htmlFor="cargo" className="form-label text-primary">Cargo que ocupa en el establecimiento</label>
                        <input type="text" className="form-control form-control-sm" id="cargo" name="cargo" value={state.cargo} onChange={e => props.handleOnChangeText(e)}/>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}


export default Inscripcion;